import documentCreateElement$1 from './document-create-element.js';

var documentCreateElement = documentCreateElement$1;
var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

export { domTokenListPrototype as default };
